import axios from "axios"
import Consts from "../app/consts"
import RequestsService from "./requestsService"

export default class articleService {
  static getAllArticles(networkCode, currentPage, itemsPerPage, isRsoc, filters, sortBy, sortDirection) {
    return axios.get(Consts.BASE_API_URL + "/api/articles_report", {
      params: {
        cancelToken: RequestsService.cancelToken("articles-request"),
        network_code: networkCode,
        current_page: currentPage,
        items_per_page: itemsPerPage,
        is_rsoc: isRsoc ? 1 : 0,
        filters: filters,
        sort_by: sortBy,
        sort_direction: sortDirection,
      },
    })
  }
  static getArticlesFiltersResources() {
    return axios.get(Consts.BASE_API_URL + "/api/articles/filters_resources", {
      params: {
        cancelToken: RequestsService.cancelToken("articles-filters-request"),
      },
    })
  }

  static submitSearchArticle(title, keywords, siteCode) {
    return axios.get(Consts.BASE_API_URL + "/api/articles/fetch_article", {
      params: {
        cancelToken: RequestsService.cancelToken("article-search-request"),
        title: title,
        keywords: keywords,
        site_code: siteCode,
      },
    })
  }
}
